import { render, staticRenderFns } from "./ProcedureNavigator.vue?vue&type=template&id=62619d8b"
import script from "./ProcedureNavigator.vue?vue&type=script&lang=js"
export * from "./ProcedureNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports